import camelcaseKeys from 'camelcase-keys'

export default class Mock<T> {
  public data: T
  public loaded: Promise<T>

  constructor(public name: string) {
    this.data = {} as T
    this.loaded = import(`./data/${this.name}`).then(mod => {
      this.data = camelcaseKeys(mod.default, { deep: true })

      return this.data
    })
  }
}
